<div
  class="key-point-callout bg-neutral-0 flex items-start overflow-clip rounded-2xl border"
  [ngClass]="[customCss(), colorClasses().border]"
>
  <div
    class="dashed-gutter relative w-3 shrink-0 border-r md:w-4"
    [ngClass]="colorClasses().border"
    [style.background-image]="gutterBackgroundImage()"
  ></div>

  <div class="flex flex-1 flex-col gap-2 p-4 md:gap-3 md:p-5">
    <div class="flex items-center gap-2" contenteditable="false">
      @if (isEditable()) {
        <div [matMenuTriggerFor]="iconPicker" class="flex shrink-0 cursor-pointer" dojoStopPropagation>
          <dojo-icon [icon]="icon()" [ngClass]="colorClasses().text" [size]="14" />
        </div>
        <mat-menu #iconPicker="matMenu" class="icon-picker-menu">
          <div class="icon-picker-grid">
            @for (availableIcon of availableIcons; track availableIcon) {
              <button
                type="button"
                class="icon-picker-item"
                [ngClass]="{ 'icon-picker-item-selected': icon() === availableIcon }"
                (click)="updateProp('icon', availableIcon)"
              >
                <dojo-icon [icon]="availableIcon" [size]="16" />
              </button>
            }
          </div>
        </mat-menu>
      } @else {
        <div class="shrink-0">
          <dojo-icon [icon]="icon()" [ngClass]="colorClasses().text" [size]="14" />
        </div>
      }
      <span
        #titleElement
        class="text-xs font-bold uppercase leading-4 outline-none"
        [ngClass]="colorClasses().text"
        [attr.contenteditable]="isEditable()"
        (input)="updateTitle($event)"
        (keydown.enter)="$event.preventDefault()"
        dojoStopPropagation
      ></span>
      @if (isEditable()) {
        <div class="ml-auto" dojoStopPropagation>
          <dojo-single-select
            [formCtrl]="colorCtrl"
            [options]="colorOptions"
            optionLabel="label"
            optionValue="value"
            [compact]="true"
            [hideErrors]="true"
            [size]="'s'"
            panelClass="color-picker-panel"
            (selectionChange)="updateProp('color', $event)"
            [hideSingleSelectionIndicator]="true"
          >
            <ng-template [dojoSelectOption]="selectOptionType" let-colorOption>
              <div class="mx-auto h-5 w-5 rounded-full" [ngClass]="colorOption.colorClass"></div>
            </ng-template>

            <ng-template [dojoSelectTrigger]="selectOptionType" let-colorOption>
              <div class="mx-auto h-5 w-5 rounded-full" [ngClass]="colorOption?.colorClass"></div>
            </ng-template>
          </dojo-single-select>
        </div>
      }
    </div>

    <div class="key-point-callout-content" tiptapNodeViewContent></div>
  </div>
</div>
